import { render } from "./TheAnamnesisResultsModal.vue?vue&type=template&id=b789526a&ts=true"
import script from "./TheAnamnesisResultsModal.vue?vue&type=script&lang=ts"
export * from "./TheAnamnesisResultsModal.vue?vue&type=script&lang=ts"

import "./TheAnamnesisResultsModal.vue?vue&type=style&index=0&id=b789526a&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__